import { AggInputData } from '@/api/workOrders/types';
import { fmtCurrency } from '@/helpers';
import {
  Box,
  TableBody,
  TableContainer,
  TableRow,
  Typography,
  alpha,
} from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { CellContent, CellHeader, StyledTable } from '../../styles';
import { isVariationComplete } from '../utils/completionCheckers';

interface VariationProps {
  variationAgg: AggInputData;
}

export const Variation = memo(function Variation(props: VariationProps) {
  const { variationAgg } = props;
  return (
    <Box id="fac-variation">
      <Box display="flex" alignItems="center" gap={1}>
        <GroupStatusIcon isComplete={isVariationComplete(variationAgg)} />
        <Typography my={3} fontWeight={600}>
          Variação
        </Typography>
      </Box>
      <TableContainer>
        <StyledTable aria-label="tabela-dados-variação">
          <TableBody>
            <TableRow>
              <CellHeader
                align="center"
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.light, 0.1),
                  width: '25%',
                }}
              >
                Preço total médio
              </CellHeader>
              <CellContent align="center" sx={{ width: '25%' }}>
                <Typography fontWeight={600}>
                  {fmtCurrency(variationAgg.mean_total_price)}
                </Typography>
              </CellContent>
              <CellHeader
                align="center"
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.light, 0.1),
                  width: '25%',
                }}
              >
                Valor unitário médio com fator de oferta
              </CellHeader>
              <CellContent align="center" sx={{ width: '25%' }}>
                <Typography fontWeight={600}>
                  {fmtCurrency(variationAgg.mean_ppsm_with_offer)}
                </Typography>
              </CellContent>
            </TableRow>
            <TableRow>
              <CellHeader
                align="center"
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.light, 0.1),
                }}
              >
                Preço unitário médio
              </CellHeader>
              <CellContent align="center">
                <Typography fontWeight={600}>
                  {fmtCurrency(variationAgg.mean_ppsm)}
                </Typography>
              </CellContent>
              <CellHeader
                align="center"
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.light, 0.1),
                }}
              >
                Desvio padrão com fator oferta
              </CellHeader>
              <CellContent align="center">
                <Typography fontWeight={600}>
                  {fmtCurrency(variationAgg.std_ppsm_with_offer)}
                </Typography>
              </CellContent>
            </TableRow>
            <TableRow>
              <CellHeader
                align="center"
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.light, 0.1),
                }}
              >
                Desvio padrão
              </CellHeader>
              <CellContent align="center">
                <Typography fontWeight={600}>
                  {fmtCurrency(variationAgg.std_ppsm)}
                </Typography>
              </CellContent>
              <CellHeader
                align="center"
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.light, 0.1),
                }}
              >
                Coeficiente de variação
              </CellHeader>
              <CellContent align="center">
                <Typography fontWeight={600}>
                  {variationAgg.coeff_ppsm != null
                    ? `${variationAgg.coeff_ppsm}%`
                    : '-'}
                </Typography>
              </CellContent>
            </TableRow>
          </TableBody>
        </StyledTable>
      </TableContainer>
    </Box>
  );
});
